import React from 'react';

import { useCommitOrder } from 'hooks/commit-order';
import DeliveryConfirmation from 'pages/order-confirmation/delivery/delivery-confirmation';
import { useLogger } from 'state/logger';

import { StyledModal } from './details-modal.styled';

const IsEnRouteModal: React.FC<{
  rbiOrderId: string;
  onModalDismiss: (orderId: string) => void;
}> = ({ rbiOrderId, onModalDismiss }) => {
  const logger = useLogger();

  const { serverOrder } = useCommitOrder({
    logger,
    rbiOrderId,
  });

  return (
    <StyledModal
      onDismiss={() => onModalDismiss('')}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Order Details',
      }}
    >
      {serverOrder && <DeliveryConfirmation serverOrder={serverOrder} isInsideModal />}
    </StyledModal>
  );
};

export default IsEnRouteModal;
